import { CommonModule, DOCUMENT } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  inject,
} from '@angular/core';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { DateRangePickerService } from '../../date-range-picker.service';
import { ModalService } from '@services/modal/modal.service';
import { DateRangePickerMonthComponent } from '../../date-range-picker-month/date-range-picker-month.component';
import { SvgIconComponent } from '@components/svg-icon/svg-icon.component';
import { delay, take } from 'rxjs';

@Component({
  selector: 'app-date-range-picker-mobile-modal',
  standalone: true,
  imports: [
    CommonModule,
    ScrollingModule,
    DateRangePickerMonthComponent,
    SvgIconComponent,
  ],
  templateUrl: './date-range-picker-mobile-modal.component.html',
  styleUrl: './date-range-picker-mobile-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateRangePickerMobileModalComponent implements OnInit {
  @Input() headerTitle = '';
  @Input() confirmButtonText = '';
  @Input() skipButtonText = '';
  @Input() withSkip = false;

  private dateRangePickerService = inject(DateRangePickerService);
  private modalService = inject(ModalService);
  private document = inject(DOCUMENT);

  months$ = this.dateRangePickerService.months$;
  scrollToMonthId$ = this.dateRangePickerService.scrollToMonthId$;

  ngOnInit() {
    this.scrollToMonth();
  }

  onCloseClick() {
    this.modalService.hide();
  }

  onConfirmClick() {
    this.modalService.hide();
  }

  onSkipClick() {
    this.dateRangePickerService.onClickSkip();
    this.modalService.hide();
  }

  private scrollToMonth() {
    this.scrollToMonthId$.pipe(delay(100), take(1)).subscribe((id) => {
      if (!id) {
        return;
      }

      this.document.getElementById(id)?.scrollIntoView({
        block: 'start',
        inline: 'start',
      });
    });
  }
}
